import React from 'react';
import { Link } from 'react-router-dom';

import { DIRECTORY } from './directory_list.js';
import './directory_new.css';

function DirectoryNew(props) {
    const {
        history, 
        files, 
        urlKey, 
        selectDirectory, 
        prevDirectory, 
        rootDirectory, 
        selectFile, 
        encryptURL
    } = props;

    let current_directory = DIRECTORY;

    for (let i = 0; i < history.length; i++) {
        current_directory = current_directory[history[i]]; 
    }

    if (urlKey) {
        return (
            <div className='_directory'>
                <div className='header'>
                    <p>{history.map(directory => (
                        directory + ' / '
                    ))}</p>
                    <div className='header'>
                        <button className='btn' onClick={rootDirectory}>
                            <i className='fas fa-home'></i>
                        </button>
                        <button className='btn' onClick={prevDirectory}>
                            <i className='fas fa-arrow-left'></i>
                        </button>
                    </div>
                </div>
                {current_directory === null 
                    ?   files.length > 0 && <div className='body'>
                            {files.map((file, f) => (
                                <div className='file' key={f}>
                                    <input
                                        className='checkbox'
                                        type='checkbox'
                                        value={file.fullPath}
                                        onChange={selectFile}
                                    />
                                    <Link
                                        className='link'
                                        to={`/pdf/${encryptURL(file.fullPath)}`}
                                    >
                                        {file.name}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    :   <div>
                            {Object.keys(current_directory).map((directory, d) => (
                                <div key={d} className='directory' onClick={() => selectDirectory(directory)}>
                                    <p>{directory}</p>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <i className='icon fas fa-angle-right'></i>
                                </div>
                            ))}
                        </div>
                }
            </div>
        );
    }
    else return <div className='_directory'></div>
}

export default DirectoryNew;